import Swiper from "swiper";

import { Virtual, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperPropertyItem() {
    new Swiper(".property-item__swiper", {
        modules: [Virtual, Navigation],

        // Params
        virtual: true,
        loop: true,
        allowTouchMove: false,
        speed: 800,

        // Navigation
        navigation: {
            prevEl: ".property-item__swiper > .swiper-button-prev",
            nextEl: ".property-item__swiper > .swiper-button-next",
        },

        // Parallax
        watchSlidesProgress: true,
        on: {
            progress() {
                const swiper = this;

                const parallaxFactor = 0.5;
                const parallaxOffset = swiper.width * parallaxFactor;

                swiper.slides.forEach((slide) => {
                    const parallaxTranslate = slide.progress * parallaxOffset;
                    const parallaxElement = slide.firstElementChild;

                    if (parallaxElement) {
                        parallaxElement.style.transform = `translate3d(${parallaxTranslate}px, 0, 0)`;
                    }
                });
            },
        },
    });
}
